<h2 mat-dialog-title>Wyszukaj dane firmy w bazie GUS</h2>
<mat-dialog-content [formGroup]="findCompany" *ngIf="this.findCompany">
  <mat-form-field appearance="outline">
    <mat-label>NIP</mat-label>
    <input #nip matInput formControlName="nip"/>
    <mat-error *ngIf="findCompany.get('nip').hasError('maxlength') ||
                      findCompany.get('nip').hasError('minlength') ||
                      findCompany.get('nip').hasError('pattern')">
      Niepoprawny numer NIP
    </mat-error>
  </mat-form-field>
  <mat-form-field appearance="outline">
    <mat-label>REGON</mat-label>
    <input #regon matInput formControlName="regon"/>
    <mat-error *ngIf="findCompany.get('regon').hasError('maxlength') ||
                      findCompany.get('regon').hasError('minlength') ||
                      findCompany.get('regon').hasError('pattern')">
      Niepoprawny numer REGON
    </mat-error>
  </mat-form-field>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-raised-button
          action-button
          color="primary"
          class="width-100"
          [disabled]="findCompany.invalid"
          [action]="findCompanyInGUS.bind(this)">
    Wyszukaj
  </button>
</mat-dialog-actions>
